import { cms } from './config';

const ARTICLES_PER_PAGE = 3;

async function getArticles(params, content) {
  try {
    const { data } = await cms.get('', {
      params: { contentType: content, ...params },
    });
    return { data: data || [] };
  } catch (error) {
    return { data: [], error };
  }
}

export async function getList(contentType, page = 1, categorySlug = undefined) {
  const skip = page > 1 ? (Number(page) - 1) * ARTICLES_PER_PAGE : undefined;
  return getArticles(
    {
      limit: ARTICLES_PER_PAGE,
      skip,
      'fields.categories.slug[eq]': categorySlug,
      withLinks: true,
    },
    contentType
  );
}

export async function getIndexedList(contentType, page = 1, categorySlug = undefined, descending = false) {
  const skip = page > 1 ? (Number(page) - 1) * ARTICLES_PER_PAGE : undefined;
  const order = descending ? '-fields.index' : 'fields.index';
  return getArticles(
    {
      limit: ARTICLES_PER_PAGE,
      skip,
      'fields.categories.slug[eq]': categorySlug,
      withLinks: true,
      sort: order,
    },
    contentType
  );
}

export async function getArticlesPage(params, contentType) {
  setTimeout(() => {}, 10);
  return getArticles(params, contentType);
}

export async function getLatest(contentType) {
  return getArticles({ limit: 4 }, contentType);
}

export async function getCmsPaths(contentType) {
  const {
    data: { data: articles = [] },
  } = await getArticlesPage({ limit: 500 }, contentType);

  return articles.map(({ slug = '' }) => ({
    params: { slug },
  }));
}

export async function getCmsAllPaths(contentType) {
  const {
    data: {
      pagination: { lastPage: totalCalls },
      data: articles = [],
    },
  } = await getArticlesPage({ limit: 500 }, contentType);
  let allArticles = [...articles];
  if (totalCalls > 1) {
    for (let i = 1; i < totalCalls; i++) {
      const {
        data: { data: newArticles = [] },
        /* eslint-disable-next-line no-await-in-loop */
      } = await getArticlesPage({ limit: 500, skip: 500 * i }, contentType);
      allArticles = [...allArticles, ...newArticles];
    }
  }
  return allArticles.map(({ slug = '' }) => ({
    params: { slug },
  }));
}
